import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
// import StatsSection from "../components/StatsSection";
import ServicesSection from "../components/ServicesSection";
import OurProducts from "../components/OurProducts";
import WhyChooseUs from "../components/WhyChooseUs";
import ProcessSection from "../components/ProcessSection";
// import CTASection from "../components/CTASection";
import Footer from "../components/Footer";
import BrandsPartners from "../components/BrandsPartners";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";

const Home = () => {
  return (
    <>
      <Navbar />

      <section id="hero" className="scroll-mt-24">
        <Hero />
      </section>

      {/* <section id="stats" className="scroll-mt-24">
        <StatsSection />
      </section> */}

      <section id="about" className="scroll-mt-30">
        <About />
      </section>

      <section id="services" className="scroll-mt-30">
        <ServicesSection />
      </section>

      <section id="products" className="scroll-mt-30">
        <OurProducts />
      </section>

      <section id="why-choose-us" className="scroll-mt-30">
        <WhyChooseUs />
      </section>

      <section id="brands" className="scroll-mt-24">
        <BrandsPartners />
      </section>

      <section id="process" className="scroll-mt-30">
        <ProcessSection />
      </section>

      <section id="testimonials" className="scroll-mt-30">
        <Testimonials />
      </section>

      <section id="faq" className="scroll-mt-30">
        <FAQ />
      </section>

      <section id="contact" className="scroll-mt-30">
        <Contact />
      </section>

      <Footer />
    </>
  );
};

export default Home;